import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useCreditCardSetupContext } from './CreditCardSetUp.context';
import { canEnableCreditCardForCash } from './CreditCardSetup.utils';

type CreditCardForCashEligibility = Readonly<{
  canEnableCreditCard: boolean;
  registryKycLaterEnabled: boolean;
  loading: boolean;
}>;

/**
 * Determines whether credit card payments can be enabled for cash funds
 * based on the payout account's KYC status and the kycLaterForRegistry feature flag.
 *
 * - Flag off: only `readyToUse` accounts can enable credit card
 * - Flag on: `onboarding`, `pending`, and `readyToUse` accounts can enable credit card
 */
export const useCreditCardForCashEligibility = (): CreditCardForCashEligibility => {
  const { payoutAccountInfo, fetchingPayoutInfo } = useCreditCardSetupContext();
  const [registryKycLaterEnabled, kycFlagLoading] = useIsFeatureEnabled('registryKycLaterEnabled');

  const loading = fetchingPayoutInfo || kycFlagLoading;
  const canEnableCreditCard = !loading && !!payoutAccountInfo && canEnableCreditCardForCash(payoutAccountInfo.status, registryKycLaterEnabled);

  return { canEnableCreditCard, registryKycLaterEnabled, loading };
};
